import { FormControl, InputLabel, Select, MenuItem, Checkbox, SelectChangeEvent } from '@mui/material';
import { FilterItemProps } from '../_common';
import { useState } from 'react';

interface MultiSelectFilterProps<OT> extends FilterItemProps<OT[]> {
    options: OT[];
    defaultValues: string[];
    getOptionValue: (option: OT) => string;
    renderOptionLabel: (option: OT) => string;
}

export function MultiSelectFilter<OT>({
    value,
    options,
    defaultValues,
    getOptionValue,
    renderOptionLabel,
}: MultiSelectFilterProps<OT>) {

    const [optionValue, setOptionValue] = useState<string[]>(defaultValues);

    const handleChange = (event: SelectChangeEvent<typeof optionValue>) => {
        const selectedValues = event.target.value;
        const valueArray = typeof selectedValues === 'string' ? selectedValues.split(',') : selectedValues
        const newValue = options.filter((option) => valueArray.includes(getOptionValue(option)));
        const optionValues = newValue.map(getOptionValue)
        setOptionValue(optionValues)
    };

    return (
        <FormControl>
            <Select
                multiple
                value={optionValue}
                onChange={handleChange}
                renderValue={(selected) => selected.join(', ')}
                defaultValue={defaultValues}
                className='relative w-full cursor-default rounded-md bg-white pl-3 pr-10 text-left text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 focus:outline-none focus:ring-2 sm:text-sm sm:leading-6'
                sx={{
                    'focus': 'ring-[#0b6d5e]',
                }}
            >
                {options.map((option) => (
                    <MenuItem key={getOptionValue(option)} value={getOptionValue(option)}>
                        <Checkbox checked={value?.map(getOptionValue).includes(getOptionValue(option))} />
                        {renderOptionLabel(option)}
                    </MenuItem>
                ))}
            </Select>
        </FormControl >
    );
}